import {
  Box,
  Button,
  Fade,
  Grid,
  IconButton,
  Modal,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import Markdown from 'react-markdown';
import CloseIcon from '@mui/icons-material/Close';
import { display } from '../../redux/reducers/sidebar';
import { Border } from '@syncfusion/ej2-react-charts';
import dayjs from 'dayjs';
import QRCode from 'qrcode';
import { useEffect, useState } from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
const style = {
  position: 'absolute',
  // right: '10%',
  bgcolor: 'background.paper',
  boxShadow: 24,
  display: 'flex',

  flexDirection: 'column',
  padding: '0px',
  height: '90%',
  width: '70%',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%,-50% )',
};

const border = '1px solid #000';

const Cell = ({ label, value }) => (
  <Box sx={{ p: 1 }}>
    <Typography variant="caption">
      {label} : {value ? value : ' '}
    </Typography>
    {/* <Typography variant="body2">{value}</Typography> */}
  </Box>
);

const EWayBillPreview = ({ open, setOpen, data, invoiceData }) => {
  const [qrupi, setQrupi] = useState('');
  let getCompany = useSelector((state) => state?.companyReducer?.companyDetails);
  console.log(getCompany, 'getCompany');

  console.log(data, 'data');
  console.log(invoiceData, 'invoiceData');
  const genQR = async () => {
    try {
      const ewbNo = data.ewaybillno;
      const gstin = data.fromgstin;
      const dateTime = moment.unix(data.ewaybilldate).format('DD-MM-YYYY hh:mm:ss A');
      const res = await QRCode.toDataURL(`${ewbNo}/${gstin}/${dateTime}`);
      console.log(res, 'qrCodeData');
      setQrupi(res);
    } catch (error) {
      console.error('Error generating QR code', error);
    }
  };
  useEffect(() => {
    genQR();
  }, []);

  const modeFind = (mode) => {
    switch (mode) {
      case 1:
        return 'Road';
      case 2:
        return 'Rail';
      case 3:
        return 'Air';
      case 4:
        return 'Ship';

      default:
        return 'road';
    }
  };
  const transTypeFind = (mode) => {
    switch (mode) {
      case 1:
        return 'Regular';
      case 2:
        return 'Bill To-Ship To';
      case 3:
        return 'Bill From-Dispatch From';
      case 4:
        return 'Combination of 2 & 3';

      default:
        return 'Regular';
    }
  };
  let gstAmt = 0;
  let totalVal = 0;
  let cessVal = 0;
  let discount = 0;
  // const items = Array.isArray(invoiceData?.relatedinvoicelineitems)
  //   ? invoiceData.relatedinvoicelineitems
  //   : [];
  // invoiceData &&
  invoiceData?.relatedinvoicelineitems?.map((dat) => {
    console.log(dat, 'dataaaa');
    gstAmt += dat.gstamount;
    totalVal += dat.itemamount;
    cessVal += dat.cessamount;
    discount += dat.itemdiscount;
  });
  const assVal = totalVal - discount;

  const fromAdd = data?.addresses?.filter((ad) => ad.objecttype === 'Eway_Billfrom')[0];
  const toAdd = data?.addresses?.filter((ad) => ad.objecttype === 'Eway_Billto')[0];
  const dispState = data?.addresses?.filter((ad) => ad.objecttype === 'Eway_Dispatchfrom')[0].statename;
  const shipState = data?.addresses?.filter((ad) => ad.objecttype === 'Eway_Dispatchto')[0].statename;
  let TotalgstAmt = 0;
  let totalInvAmt = 0;
  let totalcessVal = 0;
  let totTax = 0;
  invoiceData?.relatedinvoicelineitems?.map((dat) => {
    console.log(dat, 'dataaaa');
    TotalgstAmt += dat.gstamount;
    totalInvAmt += dat.itemamount;
    totalcessVal += dat.cessamount;
    const assVal = dat.itemamount + dat.gstamount + dat.cessamount;
    totTax += assVal;
  });
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      closeAfterTransition
      onClose={() => setOpen(false)}
    >
      <Fade in={open}>
        <Box className="custom-scrollbar" sx={style}>
          <Box
            sx={{
              backgroundColor: 'primary.main',
              paddingTop: 1,
              display: 'flex',
              fontSize: '16px',
              fontWeight: 'bold',
              flexDirection: 'row',
              color: 'white',

              justifyContent: 'space-between',
            }}
          >
            <Box sx={{ marginLeft: '10px', marginTop: '5px' }}>Preview</Box>
            <Box sx={{ marginTop: '-2px' }}>
              <IconButton aria-label="delete" onClick={() => setOpen(false)}>
                <CloseIcon sx={{ color: 'white' }} />
              </IconButton>
            </Box>
          </Box>

          <Box
            sx={{
              overflowY: 'scroll',
              overflowX: 'hidden',
              padding: '10px',
              marginBottom: '10px',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                // border: "0.5px solid black",
                // padding: '0px 10px',
                // height: '50px',
                // marginBottom: '20px',
                // // alignItems: "center",
                // justifyContent: 'center',
                // flexDirection: 'column',
              }}
            >
              <Grid sx={{ display: 'flex' }}>
                <Typography variant="h1" sx={{ fontWeight: '700', fontSize: '20px', marginTop: '70px' }}>
                  E Way Bill
                </Typography>
                <img
                  // style={{ opacity: 0.5 }}
                  // src={qrupi}
                  src={qrupi ? qrupi : ''}
                  alt="UPI QR Code"
                  height="100px"
                />
              </Grid>
              {getCompany?.relatedcompanydetailsnew?.[0]?.companylogourl.length > 5 ? (
                <Grid>
                  <img
                    // style={{ opacity: 0.5 }}
                    // src={qrupi}
                    src={getCompany?.relatedcompanydetailsnew?.[0]?.companylogourl}
                    alt="Company Logo"
                    height="90px"
                    width="90px"
                  />
                </Grid>
              ) : null}
            </Box>

            <Grid container xs={12} sx={{ border, maxWidth: 900 }}>
              <Grid item container borderBottom={border}>
                <Grid item xs={4} borderRight={border}>
                  <Cell label="Eway Bill No" value={data.ewaybillno} />
                </Grid>
                <Grid item xs={4} borderRight={border}>
                  <Cell label="Generated Date" value={dayjs.unix(data?.ewaybilldate).format('DD/MM/YYYY')} />
                </Grid>
                <Grid item xs={4}>
                  <Cell label="Generated By" value={'Trade name'} />
                </Grid>
                {/* </Grid> */}
              </Grid>
              <Grid item container borderBottom={border}>
                <Grid item xs={4} borderRight={border}>
                  <Cell label="Mode" value={modeFind(Number(data?.modeoftransport))} />
                </Grid>
                <Grid item xs={4} borderRight={border}>
                  <Cell label="Approx Distance" value={data.distance + ' kms'} />
                </Grid>
                <Grid item xs={4}>
                  <Cell label="Valid upto" value={dayjs.unix(data?.validupto).format('DD/MM/YYYY')} />
                </Grid>
              </Grid>

              <Grid item container borderBottom={border}>
                <Grid item xs={4} borderRight={border}>
                  <Cell label="Type" value={data?.supplytype === 'O' ? 'Outward' : 'Inward'} />
                </Grid>
                <Grid item xs={4} borderRight={border}>
                  <Cell label="Document Details" value={data?.invoiceno} />
                </Grid>
                <Grid item xs={4}>
                  <Cell label="Transaction type" value={transTypeFind(Number(data?.transactiontype))} />
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={6} borderRight={border}>
                  <Box sx={{ p: 1 }}>
                    <Typography variant="caption" fontWeight={700}>
                      From
                    </Typography>
                    <Typography variant="h2">
                      <b>{data?.fromtradename}</b>
                    </Typography>
                    <Typography sx={{ whiteSpace: 'pre-line' }}>{fromAdd?.line1}</Typography>
                    <Typography variant="body2">
                      <b>GSTIN:</b> {data?.fromgstin}
                    </Typography>
                    <Typography variant="body2">
                      <b>State:</b> {fromAdd?.statename}
                    </Typography>
                    <Typography variant="body2">
                      <b>Dispatch From:</b> {dispState}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={6}>
                  <Box sx={{ p: 1 }}>
                    <Typography variant="caption" fontWeight={700}>
                      To
                    </Typography>
                    <Typography variant="h2">
                      <b>{data.totradename}</b>
                    </Typography>
                    <Typography sx={{ whiteSpace: 'pre-line' }}>{toAdd?.line1}</Typography>
                    <Typography>
                      <b>GSTIN:</b> {data?.togstin}
                    </Typography>
                    <Typography variant="body2">
                      <b>State:</b> {toAdd?.statename}
                    </Typography>
                    <Typography variant="body2">
                      <b>Ship To:</b> {shipState}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
              <Grid
                item
                xs={12}
                sx={{
                  borderLeft: 0,
                  borderRight: 0,
                  // keep these if you need separators only above/below the table:
                  borderTop: '1px solid #000',
                  borderBottom: '1px solid #000',
                }}
              >
                {/* <TableContainer sx={{ border: '1px solid black' }}> */}
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ borderRight: '1px solid #000', borderBottom: '1px solid #000', width: '50px' }}>HSN Code</TableCell>
                      <TableCell sx={{ border: '1px solid #000', borderTop: 0, width: '250px' }}>Product</TableCell>
                      <TableCell sx={{ border: '1px solid #000', borderTop: 0, width: '100px' }}>Qty</TableCell>
                      <TableCell sx={{ border: '1px solid #000', borderTop: 0, width: '20px' }}>Unit</TableCell>
                      <TableCell sx={{ border: '1px solid #000', borderTop: 0, width: '100px' }} align="right">
                        Taxable Amount
                      </TableCell>
                      {invoiceData?.relatedinvoicelineitems?.[0]?.cessamount ? (
                        <TableCell sx={{ border: '1px solid #000', borderTop: 0, width: '100px' }} align="right" colSpan={4}>
                          Cess
                        </TableCell>
                      ) : null}
                      <TableCell sx={{ border: '1px solid #000', borderTop: 0, width: '100px' }} align="right">
                        GST Tax
                      </TableCell>
                      <TableCell sx={{ borderLeft: '1px solid #000', borderBottom: '1px solid #000', width: '100px' }} align="right">
                        Total Invoice
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {invoiceData?.relatedinvoicelineitems?.map((row) => (
                      <TableRow key={row.itemid}>
                        <TableCell sx={{ borderRight: '1px solid #000', borderBottom: '1px solid #000', width: '50px' }}>
                          {row?.hsnsaccode}
                        </TableCell>
                        <TableCell sx={{ border: '1px solid #000', borderTop: 0, width: '250px' }}>{row?.itemname}</TableCell>
                        <TableCell sx={{ border: '1px solid #000', borderTop: 0, width: '100px' }}>{row?.quantity}</TableCell>
                        <TableCell sx={{ border: '1px solid #000', borderTop: 0, width: '20px' }}>{row?.unit}</TableCell>
                        <TableCell sx={{ border: '1px solid #000', borderTop: 0, width: '100px' }} align="right">
                          {row?.itemamount}
                        </TableCell>
                        <TableCell sx={{ border: '1px solid #000', width: '100px' }} align="right">
                          {row?.gstamount}
                        </TableCell>
                        {row?.cessamount ? (
                          <TableCell sx={{ border: '1px solid #000', width: '100px' }} align="right">
                            {row?.cessamount}
                          </TableCell>
                        ) : null}
                        <TableCell
                          sx={{ borderLeft: '1px solid #000', borderTop: '1px solid #000', borderBottom: '1px solid #000', width: '100px' }}
                          align="right"
                        >
                          {row?.itemamount + row?.gstamount + row?.cessamount}
                        </TableCell>
                      </TableRow>
                    ))}
                    <TableRow>
                      <TableCell colSpan={4} align="right" sx={{ borderRight: '1px solid #000' }}>
                        Total
                      </TableCell>
                      <TableCell align="right" sx={{ borderRight: '1px solid #000' }}>
                        {totalInvAmt}
                      </TableCell>
                      <TableCell align="right" sx={{ borderRight: '1px solid #000' }}>
                        {TotalgstAmt}
                      </TableCell>
                      {invoiceData?.relatedinvoicelineitems?.[0]?.cessamount ? (
                        <TableCell align="right" sx={{ borderRight: '1px solid #000' }}>
                          {totalcessVal}
                        </TableCell>
                      ) : null}
                      <TableCell align="right">{totTax}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Grid>
              <Grid
                container
                xs={12}
                sx={{
                  borderBottom: '1px solid #000',
                }}
              >
                <Grid item xs={6}>
                  <Typography
                    variant="h4"
                    sx={{
                      padding: '10px',
                    }}
                  >
                    {' '}
                    Transporter ID : {data?.transporterid ? data?.transporterid : ''}
                  </Typography>
                  <Typography
                    variant="h4"
                    sx={{
                      padding: '10px',
                    }}
                  >
                    {' '}
                    Transporter Name : {data?.transportername ? data?.transportername : ''}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography
                    variant="h4"
                    sx={{
                      padding: '10px',
                    }}
                  >
                    {' '}
                    Doc Number : {data?.transdocno ? data?.transdocno : ''}
                  </Typography>
                  <Typography
                    variant="h4"
                    sx={{
                      padding: '10px',
                    }}
                  >
                    {' '}
                    Doc Date : {data?.transdocdate ? dayjs.unix(data?.transdocdate).format('DD/MM/YYYY') : ''}
                  </Typography>
                </Grid>
              </Grid>
              {/* <Box
              sx={{
                display: 'flex',
                border: '0.5px solid black',

                // alignItems: "center",
                justifyContent: 'center',
                flexDirection: 'column',
              }}
            >
              <Typography variant="h2" sx={{ padding: '10px', fontSize: '16px', fontWeight: 'bold' }}>
                {' '}
                5. Vehicle Details
              </Typography>
            </Box> */}
              <Grid container xs={12}>
                <Grid item xs={6}>
                  <Typography
                    variant="h4"
                    sx={{
                      padding: '10px',
                    }}
                  >
                    Mode : {data?.vehicletype === 'R' ? 'Regular' : 'Over Dimensional'}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography
                    variant="h4"
                    sx={{
                      padding: '10px',
                    }}
                  >
                    Vehicle Number : {data?.vehicleno}
                  </Typography>
                </Grid>
              </Grid>
              {/* <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow
                      sx={{
                        '.MuiTableCell-root': {
                          // backgroundColor: "primary.main",
                          // fontSize: "14px",
                          padding: '0px 10px',
                          // color: "white",
                        },
                      }}
                    >
                      <TableCell>Mode : {data?.vehicletype === 'R' ? 'Regular' : 'Over Dimensional'}</TableCell>
                      <TableCell>Vehicle Number : {data?.vehicleno}</TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody></TableBody>
                </Table>
              </TableContainer> */}
            </Grid>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};

export default EWayBillPreview;
